export default function unique(arr: string[]): string[] {
  const result: string[] = [];
  arr.forEach((item) => {
    if (result.find((uniqueItem) => uniqueItem === item) != null) return;
    result.push(item);
  });
  return result;
}
